module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/128.4db94b80.png";